/**
 * Defer the country-flag sprite until the selector is actually near the viewport.
 *
 * WHY: assets/country-flags.css paints .country-flags from a single sprite —
 * country-flags-2x.png, 468KB on disk and ~152KB over the wire. The stylesheet
 * was loaded with the media="print" onload swap, which makes the CSS itself
 * non-blocking but does nothing about the sprite: as soon as the swap flips to
 * media="all" the background-image resolves and the browser fetches all 468KB.
 * On the NordBench Pro PDP that happened on every page load, while the selector
 * was CLOSED, to paint one 20x20 flag in the footer.
 *
 * A CSS background cannot be lazy-loaded natively (loading="lazy" is an <img>
 * and <iframe> attribute), so the deferral has to be the stylesheet injection
 * itself. rootMargin gives it a screen of runway, so by the time the footer is
 * on screen the flag is painted and the swap is invisible.
 *
 * Degrades safely: no IntersectionObserver (or no JS at all) loads the sheet
 * immediately, which is exactly the old behaviour.
 */
(function () {
  var SEL = '[data-country-flags-css]';

  function inject(href) {
    if (document.querySelector('link[data-country-flags-loaded="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-country-flags-loaded', href);
    document.head.appendChild(link);
  }

  function init() {
    var hosts = document.querySelectorAll(SEL);
    if (!hosts.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < hosts.length; i++) inject(hosts[i].getAttribute('data-country-flags-css'));
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        inject(entries[i].target.getAttribute('data-country-flags-css'));
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '600px 0px' });

    for (var j = 0; j < hosts.length; j++) io.observe(hosts[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
